<template>
  <div class="p-6 bg-red-900 min-h-screen flex justify-center items-center">
    <title>Pagina Ingreso a la aplicación</title>
    <div class="w-full max-w-md">
      <logo />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h1 class="text-center font-bold text-3xl">Bienvenido</h1>
          <h1 class="mt-8 justify-center items-center text-center ">
              <a aria-label="Ayuda" href="https://www.youtube.com/watch?v=gtCnMitQ_74" target="_blank"
              class="ml-auto btn-register font-bold text-black justify-center items-center">
                Ayuda
              </a>
          </h1>
          <div class="mx-auto mt-6 w-24 border-b-2" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Cuil" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Contraseña" type="password" />
          <label class="mt-6 select-none flex items-center" for="remember">
            <Link href="/forget-password" class="ml-auto font-bold text-black" method="get" alt="¿olvido su contraseña?">¿Olvido su contraseña?</Link>
          </label>
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-100 flex">
          <loading-button :loading="form.processing" class="btn-login" type="submit" aria-label="Ingresar">Ingresar</loading-button>
          <Link href="/register" class="ml-auto btn-register font-bold text-black" method="get" aria-label="Registrarse">Registrarse</Link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link } from '@inertiajs/inertia-vue'
import AccordionItem from '../../Shared/AccordionItem'

export default {
    metaInfo: { title: 'Login' },
    components: {
        AccordionItem,
        LoadingButton,
        Logo,
        TextInput,
        Link,
    },
    data() {
        return {
        form: this.$inertia.form({
            email: '',//johndoe@example.com
            password: '',//pepepepe
            remember: false,
        }),

        }
    },
    mounted(){
        if(this.$page.props.flash.success != null){
            console.log('entro al if succes')
            this.$alert(this.$page.props.flash.success, 'Aviso', {
                confirmButtonText: 'OK',
            });
        }
    },
    watch:{
        '$page.props.success':function (newError, oldError) {
            this.$alert('Vuelva a revisar su casilla de correo', 'Email Reenviado', {
                confirmButtonText: 'OK',
            });
        },
    },
    methods: {
        login() {
        this.form.post(this.route('login.store'))
        },
        resendEmail(){
            this.form.post(this.route('verification.resend'))
        }
    },
}
</script>
